import {createSelector} from 'reselect';

// basic input and output
export const selectCartReducer = (state) => state.cart;

export const selectCartItems = createSelector(
    [selectCartReducer], (cart) => cart.cartItems
);

export const selectIsCartOpen = createSelector([selectCartReducer], (cart) => cart.isCartOpen);


export const selectCartCount = createSelector([selectCartItems], (cartItems) => 
    cartItems?.reduce((total, cartItems) => total + cartItems.quantity, 0)
);

export const selectCartTotal = createSelector([selectCartItems], (cartItems) => 
    cartItems?.reduce(
        (total, cartItem) => total + cartItem.quantity * cartItem.price, 0)  
);